import { render, staticRenderFns } from "./classIvDetail.vue?vue&type=template&id=75acd0d1&scoped=true"
import script from "./classIvDetail.vue?vue&type=script&lang=js"
export * from "./classIvDetail.vue?vue&type=script&lang=js"
import style0 from "./classIvDetail.vue?vue&type=style&index=0&id=75acd0d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75acd0d1",
  null
  
)

export default component.exports